<script lang="ts">
  import Spinner from '#general/components/spinner.svelte'
  import EntityListing from '#listings/components/entity_listing.svelte'
  import EntityListingComment from '#listings/components/entity_listing_comment.svelte'
  import { getListingsByEntityUri } from '#listings/lib/listings'
  import type { SerializedEntity } from '#server/types/entity'
  import type { ListingWithElements } from '#server/types/listing'
  import { i18n, I18n } from '#user/lib/i18n'

  const {
    entity,
  }: {
    entity: SerializedEntity
  } = $props()

  const uri = $derived(entity.uri)
  const listingsWithEntityComment = $state([])
  const listingsWithoutEntityComment = $state([])

  async function getListings () {
    if (uri) {
      const listings: ListingWithElements[] = await getListingsByEntityUri(uri) || []
      for (const listing of listings) {
        if (listing.elements.find(el => el.uri === uri).comment) {
          listingsWithEntityComment.push(listing)
        } else {
          listingsWithoutEntityComment.push(listing)
        }
      }
    }
  }

  const waitingForListings = getListings()
</script>

{#await waitingForListings}
  <p class="loading">{I18n('loading')}<Spinner /></p>
{:then}
  <div class="listings-layout" class:empty={listingsWithEntityComment.length === 0}>
    <h5>{i18n('Comments')}</h5>
    {#if listingsWithEntityComment.length === 0}
      <p class="empty">
        {i18n('There is nothing here')}
      </p>
    {:else}
      <ul class="listings-list">
        {#each listingsWithEntityComment as listing (listing._id)}
          <EntityListingComment {listing} {uri} />
        {/each}
      </ul>
    {/if}
  </div>
  <div class="listings-layout" class:empty={listingsWithoutEntityComment.length === 0}>
    <h5>{i18n('Lists')}</h5>
    {#if listingsWithoutEntityComment.length === 0}
      <p class="empty">
        {i18n('There is nothing here')}
      </p>
    {:else}
      <ul class="listings-list">
        {#each listingsWithoutEntityComment as listing (listing._id)}
          <EntityListing {listing} />
        {/each}
      </ul>
    {/if}
  </div>
{/await}

<style lang="scss">
  @import "general/scss/utils";
  .listings-layout{
    padding: 0.5em 1em;
    background-color: $off-white;
    @include radius;
    align-self: stretch;
    &.empty{
      @include display-flex(row, center, space-between);
    }
    &:not(.empty){
      h5{
        margin-block-end: 1em;
      }
    }
    /* Small screens */
    @media screen and (width < $small-screen){
      margin: 1rem 0 0;
    }
    /* Large screens */
    @media screen and (width >= $small-screen){
      margin: 0.5rem 0;
    }
  }
  .listings-list{
    width: 100%;
  }
  h5{
    @include sans-serif;
    padding: 0.3em 0.5em;
  }
  .loading{
    @include display-flex(column, center);
  }
  p.empty{
    color: $grey;
    text-align: center;
  }
</style>
